import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  "@keyframes pingPong": {
    "0%, 100%": { transform: "translateX(-10px)" },
    "50%": { transform: "translateX(10px)" }
  },
  "@keyframes scan": {
    "0%": { transform: "translate(0, 0)" },
    "25%": { transform: "translate(4px, -4px)" },
    "50%": { transform: "translate(-2px, 6px)" },
    "75%": { transform: "translate(-6px, -2px)" },
    "100%": { transform: "translate(0, 0)" }
  },
  "@keyframes pulseSubtle": {
    "0%, 100%": { opacity: 1, transform: "scale(1)" },
    "50%": { opacity: 0.7, transform: "scale(1.05)" }
  },
  statusIconWrapper: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    height: "40px",
    position: "relative"
  },
  loaderBar: {
    width: "12px",
    height: "4px",
    backgroundColor: "#3b82f6",
    borderRadius: "2px",
    animation: "$pingPong 1.5s ease-in-out infinite"
  },
  scanIcon: {
    animation: "$scan 2s linear infinite"
  },
  pulseIcon: {
    animation: "$pulseSubtle 2s ease-in-out infinite"
  },
  textSuccess: {
    color: "#2e7d32"
  },
  textError: {
    color: "#d32f2f"
  },
  textInfo: {
    color: "#0288d1"
  },
  textWarning: {
    color: "#ed6c02"
  }
}));

export const ConnectedIcon: React.FC = () => {
  const styles = useStyles();
  return (
    <div className={styles.statusIconWrapper}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.textSuccess}>
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
      </svg>
    </div>
  );
};

export const DisconnectedIcon: React.FC = () => {
  const styles = useStyles();
  return (
    <div className={styles.statusIconWrapper}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.textError}>
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="currentColor"/>
      </svg>
    </div>
  );
};

export const FetchingIpIcon: React.FC = () => {
  const styles = useStyles();
  return (
    <div className={styles.statusIconWrapper}>
      <div className={styles.loaderBar}></div>
    </div>
  );
};

export const VerifyingIpIcon: React.FC = () => {
  const styles = useStyles();
  return (
    <div className={styles.statusIconWrapper}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ opacity: 0.3 }}>
        <path d="M20 13H4V11H20V13ZM20 17H4V15H20V17ZM20 9H4V7H20V9Z" fill="currentColor"/>
      </svg>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${styles.scanIcon} ${styles.textInfo}`} style={{ position: "absolute" }}>
        <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="currentColor"/>
      </svg>
    </div>
  );
};

export const VerifyingAltIpIcon: React.FC = () => {
  const styles = useStyles();
  return (
    <div className={styles.statusIconWrapper}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ opacity: 0.3 }}>
        <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04Z" fill="currentColor"/>
      </svg>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${styles.scanIcon} ${styles.textInfo}`} style={{ position: "absolute" }}>
        <path d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z" fill="currentColor"/>
      </svg>
    </div>
  );
};

export const ConnectedUnreachableIcon: React.FC = () => {
  const styles = useStyles();
  return (
    <div className={styles.statusIconWrapper}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.textSuccess}>
        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
      </svg>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${styles.pulseIcon} ${styles.textWarning}`} style={{ position: "absolute", bottom: 0, right: 0, background: "white", borderRadius: "50%" }}>
        <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" fill="currentColor"/>
      </svg>
    </div>
  );
};
